<template>
  <div class="fill-height d-flex flex-column flex-grow-1">
    <h2 class="mb-2 px-2 px-sm-0">Profil uporabnika</h2>

    <v-card
      class="profile pa-lg-4 pa-2 fill-height"
      :elevation="$vuetify.breakpoint.smAndUp > 0 ? 1 : 0"
    >
      <v-btn to="/" fab color="white" exact top right absolute>
        <v-icon large color="red">mdi-close</v-icon>
      </v-btn>
      <v-form v-model="valid" ref="form">
        <div class="grid">
          <div class="left-part">
            <div class="mx-8 my-1 d-flex">
              <h4>{{ record.email }}</h4>
              <p class="ml-2">(e-naslova ne moreš spremenit)</p>
            </div>

            <v-text-field
              label="Ime"
              type="text"
              v-model="record.first_name"
              prepend-icon="mdi-smart-card-outline"
              placeholder="ime"
            />
            <v-text-field
              label="Priimek"
              type="text"
              v-model="record.last_name"
              prepend-icon="mdi-smart-card-outline"
              placeholder="priimek"
            />
            <v-text-field
              label="URL avatarja (fotografija uporabnika)"
              type="text"
              v-model="record.photo_url"
              prepend-icon="mdi-image-frame"
              placeholder="https://...."
            />
            <v-btn color="primary" @click="doUpdate">Shrani</v-btn>
          </div>
          <v-divider vertical class="d-none d-lg-flex"></v-divider>
          <div class="right-part">
            <h3 class="mt-4 mt-sm-0">Dodatno</h3>

            <v-container>
              <v-row>
                <v-col cols="4">
                  <img :src="`${record.photo_url}?s=400`" />
                  <img />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    valid: true,
    record: {
      email: "",
      first_name: "",
      last_name: "",
      photo_url: ""
    }
  }),
  computed: {
    ...mapGetters(["user", "loggedIn"])
  },
  mounted() {
    this.$axios
      .get(`/users/${this.user.data.email}`)
      .then(response => (this.record = eval(response.data)));
  },
  methods: {
    doUpdate() {
      const that = this;
      user
        .updateProfile({
          displayName: this.displayName,
          photoURL: this.photoURL
        })
        .then(function() {
          // console.log("Profile updated");
          that.$store.dispatch("setUserData", user);
          that.$router.replace({ name: "Home" });
        })
        .catch(function(error) {
          alert(error);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 3rem;
}

.twocol {
  display: grid;
  grid-template-columns: 1fr;
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .grid {
    grid-template-columns: 40rem 1px 1fr;
  }

  .twocol {
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
  }
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.left-part > * {
  margin: 0;
}
</style>
